export default "__VITE_ASSET__k4I5OCS1__"